// @flow
import type { FacetOption as FacetOptionType } from '../../types/FacetOption';
import Radio from 'react-bootstrap/lib/Radio';
import React from 'react';
import styles from './ToggleStyles.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    onChange: Function,
    option: FacetOptionType,
};

const RadioFacet = (props: Props) => {
    const { onChange, option } = props;

    return (
        <div className={styles.toggleOption}>
            <Radio
                checked={option.selected}
                className={styles.toggler}
                disabled={option.count === 0}
                name="distance"
                onChange={onChange}
                value={option.id}
            >
                <Text secondary className={styles.optionName}>
                    {option.name}
                    {!isNaN(option.count) && (
                        <Text caption className={styles.optionResultsCount}>
                            <span> ({Number(option.count).toLocaleString()})</span>
                        </Text>
                    )}
                </Text>
            </Radio>
        </div>
    );
};

export default React.memo<Props>(RadioFacet);
